var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8539 12.2222C14.7543 11.9712 14.5723 11.7524 14.3315 11.594C14.0907 11.4356 13.8021 11.3448 13.5027 11.3333H11.5012C11.103 11.3333 10.7213 11.4738 10.4398 11.7238C10.1583 11.9739 10 12.313 10 12.6667C10 13.0203 10.1583 13.3594 10.4398 13.6095C10.7213 13.8595 11.103 14 11.5012 14H13.5027C13.9009 14 14.2826 14.1405 14.5641 14.3905C14.8456 14.6406 15.0039 14.9797 15.0039 15.3333C15.0039 15.687 14.8456 16.0261 14.5641 16.2762C14.2826 16.5262 13.9009 16.6667 13.5027 16.6667H11.5012C11.2018 16.6552 10.9132 16.5644 10.6724 16.406C10.4316 16.2476 10.2496 16.0288 10.15 15.7778M12.502 10V11.3333M12.502 16.6667V18",
    stroke: "#C1C5CF",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.69231V4.23077C8.5 3.55103 9.06225 3 9.75581 3H15.2442C15.9378 3 16.5 3.55103 16.5 4.23077V6.69231M5.51163 21H19.4884C20.8755 21 22 19.8979 22 18.5385V9.15385C22 7.79438 20.8755 6.69231 19.4884 6.69231H5.51163C4.12449 6.69231 3 7.79438 3 9.15385V18.5385C3 19.8979 4.12449 21 5.51163 21Z",
    stroke: "#C1C5CF",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/Portfolio.5097111da978bdc9dd101cff7954461c.svg";
export { ForwardRef as ReactComponent };